import React, { useEffect } from "react";
import "./Modal.css";

const Modal = ({ isOpen, onClose, title }) => {
  
  // Close modal when clicking outside the content
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (e.target.classList.contains("modal-overlay")) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-title">{title}</h2>
        
        <div className="modal-body">
          {/* Clinic Timings */}
          <h3>🕐 Clinic Timings</h3>
          
            <p>Monday - Saturday: 10:00 AM - 8:00 PM</p>
            <p>Sunday: Closed</p>
          

          {/* Doctor's Contact */}
          <h3>📞 Doctor's Contact</h3>
          <p>Phone: +91 80974 46666</p>
          <p>Email: shivanivetkar123@gmail.com</p>

          <p>_______________________________________</p>
          {/* Vision & Mission */}
          <h3>🌟Developer</h3>
          <p>
            <strong>Yash Vinayak Dongare</strong>
            <p>Email: yashdongare050@gmail.com</p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Modal;